import script from "./DebugTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugTable.vue?vue&type=script&setup=true&lang=js"

import "./DebugTable.vue?vue&type=style&index=0&id=2fb70625&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb70625"]])

export default __exports__